module.exports = __webpack_public_path__ + "static/img/img(60).6d5b3df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(60).png
// module id = dnYY
// module chunks = 1